<template>
  <div class="list-main">
    <div class="main-header">
      <div class="head-title">我的消息</div>
      <div class="head-line"></div>
      <div class="head-modal">
        <span class="label">消息标题</span>
        <input
          v-model="listQuery.title"
          style="margin-right: 60px"
          type="text"
          @keyup.enter="requestList"
        />
        <div class="search-btn" @click="requestList">查询</div>
      </div>
    </div>
    <div class="main-content">
      <el-table
        empty-text="暂无数据"
        class="message-list"
        :data="tableData"
        stripe
        style="width: 989px"
        :show-header="false"
      >
        <el-table-column header-align="center" label="考试名称">
          <template slot-scope="scope">
            <span style="padding-left: 32px" class="exam-name">{{
              scope.row.examName
            }}</span>
            <div class="list-item">
              <div class="item-head">
                {{ scope.row.title }}
              </div>
              <div class="item-center">
                <el-badge is-dot class="item" v-if="!scope.row.isRead">
                  <img
                    class="content-left"
                    src="../../../assets/home/message-item-icon.png"
                    alt=""
                  />
                </el-badge>
                <img
                  v-else
                  class="content-left"
                  src="../../../assets/home/message-item-icon.png"
                  alt=""
                />
                <div class="content-center">{{ scope.row.content }}</div>
                <div class="content-right">
                  <div class="detail-btn">查看详情</div>
                </div>
              </div>
              <div class="item-bottom">
                <div class="message-date">
                  {{
                    moment(scope.row.sendTime, "YYYY-MM-DD").format(
                      "YYYY-MM-DD"
                    )
                  }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div
        class="message-list"
        style="padding: 0 3vw; height: 100%; padding-top: 16px"
        ref="vanLearn"
        v-if="tableData.length != 0"
      >
        <template v-for="(item, index) in tableData">
          <div
            class="list-item"
            v-if="index < 4"
            :key="index"
            @click="goDetail(item)"
          >
            <div class="item-head">
              {{ item.title }}
            </div>
            <div class="item-center">
              <img
                class="content-left"
                src="../../../assets/home/message-item-icon.png"
                alt=""
              />
              <div class="content-center">{{ item.content }}</div>
              <div class="content-right">
                <div class="detail-btn">查看详情</div>
              </div>
            </div>
            <div class="item-bottom">
              <div class="message-date">
                {{ moment(item.sendTime, "YYYY-MM-DD").format("YYYY-MM-DD") }}
              </div>
            </div>
          </div>
        </template>
      </div> -->
      <div
        style="
          position: absolute;
          bottom: 0;
          height: 30px;
          margin: 36px auto;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
        "
      >
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          background
          layout="total,  prev, pager, next, jumper"
          :total="total"
          :page-size="4"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Nav from "@/components/nav.vue";
import Api from "@/api/user";
export default {
  components: { Nav },
  data() {
    return {
      total: 0,
      page: 1,
      pageSize: 4,
      tableData: [],
      listQuery: {
        SkipCount: 0,
        MaxResultCount: 4,
        sourceTypeList: [],
        title: "",
      },
      activeType: "make",
    };
  },
  methods: {
    moment,
    goBack() {
      this.$router.back();
    },
    jscomNewOpenMaxWindow(url, target) {
      let tt, w, left, top, width, height;
      width = screen.width;
      height = screen.height - 60;
      left = 0;
      if (left < 0) {
        left = 0;
      }

      top = 0;
      if (top < 0) {
        top = 0;
      }

      tt =
        "toolbar=no, menubar=no, scrollbars=yes,resizable=no,location=no, status=yes,fullscreen=yes,";
      tt =
        tt +
        "width=" +
        width +
        ",height=" +
        height +
        ",left=" +
        left +
        ",top=" +
        top;
      w = window.open(url, target, tt);
      try {
        w.focus();
        return w;
      } catch (e) {}
    },
    goAnswerPaper(item) {
      if (item.isAllowSeePaper && item.gradeStatusCodeName != "考试中") {
        let routeData = this.$router.resolve({
          path: "/exam/paper/detail",
          query: { examUid: item.examUid, examGradeUid: item.examGradeUid },
        });
        this.jscomNewOpenMaxWindow(routeData.href, "_blank");
        // this.$router.replace(`/exam/paper/detail?examUid=${item.examUid}&examGradeUid=${item.examGradeUid}`);
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.requestList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.requestList();
    },
    requestList() {
      if (this.pageSize) {
        this.listQuery.MaxResultCount = this.pageSize;
      }
      this.listQuery.SkipCount =
        (this.page - 1) * this.listQuery.MaxResultCount;
      Api.getMessageList(this.listQuery)
        .then((res) => {
          this.tableData = res.data.items;
          this.total = res.data.totalCount;
          this.tableData.forEach((item) => {
            if (item.beginTimeFormat) {
              item.beginTimeFormat =
                item.beginTimeFormat.split(" ")[0] +
                " " +
                item.beginTimeFormat.split(" ")[1].split(":")[0] +
                ":" +
                item.beginTimeFormat.split(" ")[1].split(":")[1];
            }
            if (item.endTimeFormat) {
              item.endTimeFormat =
                item.endTimeFormat.split(" ")[0] +
                " " +
                item.endTimeFormat.split(" ")[1].split(":")[0] +
                ":" +
                item.endTimeFormat.split(" ")[1].split(":")[1];
            }
          });
        })
        .catch((err) => {
          console.warn(err);
        });
    },
  },
  created() {
    this.requestList();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table .el-table__cell {
  padding: 0 !important;
}
::v-deep .el-input__inner {
  height: 100%;
  border: none;
  padding-left: 32px;
}
::v-deep .el-table__row {
  height: 54px;
  //   border: none;
  //   padding-left: 32px;
}
.customer-table {
  margin: 0 auto;
  th {
    padding: 0 !important;
    height: 48px;
    line-height: 48px;
  }
  td {
    padding: 0 !important;
    height: 48px;
    line-height: 48px;
  }
}
.el-menu {
  background-color: initial;
}
.list-main {
  // width: 100%;
  width: 1070px;

  height: 100%;
  .exam-name {
    font-size: 14px;
    font-weight: 600;
    // font-family: PingFangSC, PingFangSC-Medium;
    text-align: left;
    color: #000000;
    line-height: 15px;
  }
  .handle-btn {
    width: 84px;
    cursor: pointer;
    height: 30px;
    border: 1px solid #979797;
    border-radius: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    &:hover {
      background: #1fa3ff;
      color: #fff;
      border: none;
    }
  }
  .main-header {
    padding-top: 40px;
    width: 989px;
    margin: 0 auto;
    // display: flex;
    margin-bottom: 18px;
    // justify-content: space-between;
    // align-items: center;
    .head-title {
      width: 100%;
      font-size: 20px;
      font-weight: 600;
      text-align: left;
      color: #000000;
      line-height: 28px;
      padding-bottom: 26px;
      //   margin-bottom: ;
    }
    .head-line {
      width: 100%;
      height: 1px;
      opacity: 0.1;
      background: #3e4294;
    }
    .head-modal {
      display: flex;
      align-items: center;
      padding-top: 28px;
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      color: #666666;
      .label {
        margin-right: 20px;
      }
      .search-btn {
        width: 95px;
        height: 40px;
        background: #1fa3ff;
        border-radius: 10px;
        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.02);
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
      }
      input {
        width: 190px;
        height: 40px;
        background: #f5f5f7;
        border-radius: 10px;
        outline: none;
        border: none;
        padding: 0 18px;
      }
    }
  }

  .main-content {
    position: relative;
    height: 570px;
    overflow: hidden;
    .message-list {
      margin: 0 auto;
      .list-item {
        // padding-top: 24px;
        // height: 122px;
        height: 99px;
        border-bottom: 1px solid #e6eaf3;
        .item-head {
          width: 100%;
          padding-left: 52px;
          font-size: 14px;
          font-weight: 600;
          text-align: left;
          color: #000000;
          line-height: 28px;
        }
        .item-center {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          .content-left {
            width: 36px;
            height: 36px;
          }
          .content-center {
            width: 788px;
            padding-left: 16px;
            text-align: left;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            overflow: hidden;
            // height: 26px;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-right: 60px;
          }
          .content-right {
            .detail-btn {
              width: 84px;
              height: 30px;
              background: #1fa3ff;
              border-radius: 16px;
              font-size: 14px;
              font-weight: 400;
              text-align: center;
              color: #ffffff;
              line-height: 30px;
              cursor: pointer;
            }
          }
        }
        .item-bottom {
          .message-date {
            padding-left: 52px;
            font-size: 12px;
            font-weight: 300;
            text-align: left;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
<style>
/* .main-content .el-table th.is-leaf, */
.main-content .el-table td,
.main-content .el-table--border,
.main-content .el-table__body-wrapper {
  /* grey */
  border: none;
  /* cursor: pointer; */
}
.main-content .el-table::before {
  height: 0;
}
</style>